<template>
  <div v-if="event" class="flex flex--top cal-day-info cursor-p">
    <h2>{{ getTime(event.end) }} - {{ getTime(event.start) }}</h2>
    <div
      class="cal-day-info-list is--fit flex flex--start"
      @click="$router.push('/app-info/' + event.id)"
    >
      <div class="flex line-clamp">
        <span v-if="$route.name == 'surg-app-list'"
          ><span class="bold">ייעוץ</span> |</span
        >
        {{ event.patientName }} {{ event.patientPassport }} |
        {{ event.description }} {{ event.patientPhone }}
        <span v-if="event.notes">| {{ event.notes }}</span>
      </div>
    </div>
    <div class="cal-day-info-left flex flex--top">
      <div
        v-if="getBubbleStatus()"
        class="cal-day-info-left-ic status-bubble"
        :style="getBubbleStatus().color"
      >
        <img
          :src="getBubbleStatus().icon"
          :style="getBubbleStatus().iconStyle"
        />
        <span>{{ getBubbleStatus().text }}</span>
      </div>
      <div
        v-if="event.scheduled_by && getScheduledBy(event.scheduled_by)"
        class="cal-day-info-left-ic"
      >
        <img
          :src="getScheduledBy(event.scheduled_by).image"
          :alt="getScheduledBy(event.scheduled_by).text"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AppListEvent",
  props: {
    event: {
      required: true
    },
    isMobile: { default: false }
  },
  methods: {
    getTime(date) {
      return this.$moment(date).format("LT");
    },
    getScheduledBy(type) {
      return this.$store.getters["getAppScheduledBy"](type, false);
    },
    getBubbleStatus() {
      return this.$store.getters["getAppBubbleStatus"](
        this.event.status,
        this.event.arrival_approval
      );
    }
  }
};
</script>
